import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton } from "@mui/material";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
// components
import { MHidden } from "../../components/@material-extend";
//
import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
import LanguagePopover from "./LanguagePopover";
import NotificationsPopover from "./NotificationsPopover";
import { usePGIMode } from "../../Hooks/PGIModeContext";
import Logo from "src/components/Logo";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import {
  delete_member_notification,
  notification_list_with_pagination,
  read_all_notification,
  read_notification_by_id,
} from "src/DAL/Notification/Notification";
import { s3baseUrl } from "src/config/config";
import { imagePlaceHolder } from "src/assets";
import { get_root_value } from "src/utils/domUtils";
import ChatButton from "./ChatButton.jsx.js";
import CustomConfirmation from "src/components/menuIcons/CustomConfirmation";

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 42;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP + 20,
    padding: theme.spacing(0, 5),
  },
}));

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const {
    consultantInfo,
    socket,
    userInfo,
    notificationsCount,
    consultantDetail,
    isAccess,
  } = useContentSetting();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [OpenNotes, setOpenNotes] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);
  const [loadMore, setLoadMore] = useState(
    "api/feeds/notification_list_with_pagination/delegate?page=0&limit=10"
  );

  const getMoreNotificationList = async (notifications, load_path) => {
    const result = await notification_list_with_pagination(load_path);
    if (result.code === 200) {
      var newArray = notifications.concat(result.notification_array);
      setNotifications(newArray);
      setPageNumber((page) => page + 1);
      setTotalPages(result.total_pages);
      setUnreadNotificationCount(result.unread_notification_count);
      setLoadMorePath(result.load_more);
      setIsLoadingMore(false);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setIsLoadingMore(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const navigateFunction = (value) => {
    if (value.action_by == "consultant_user") {
      if (value.action_id == userInfo?._id) {
        return `/contact-support/${value._id}`;
      } else {
        return `/internal-tickets/${value._id}`;
      }
    } else {
      return `/support-ticket/${value._id}`;
    }
  };
  const navigatechangeStatus = (value) => {
    if (value.action_by == "consultant_user") {
      navigate(`/internal-tickets/needs-attention`);
    } else {
      navigate(`/support-ticket`, {
        state: { tabValue: 3 },
      });
    }
  };
  const handleRedirect = async (
    notification_id,
    feed_id,
    notification_type,
    support_ticket,
    send_id,
    data
  ) => {
    setOpen(false);

    if (data.is_seen == false) {
      setUnreadNotificationCount((old) => old - 1);
    }
    const result = await read_notification_by_id(notification_id);
    if (result.code === 200) {
      setNotifications((notifications) => {
        const notification_list = notifications.map((notification) => {
          if (notification._id === notification_id) {
            return {
              ...notification,
              is_seen: true,
            };
          } else {
            return notification;
          }
        });
        return notification_list;
      });
      if (notification_type === "goal_statement") {
        navigate(`/goal-statement`);
      } else if (notification_type == "support_ticket") {
        navigate(navigateFunction(support_ticket), {
          state: { open: false, support_ticket },
        });
      } else if (notification_type == "support_ticket_comment") {
        navigate(navigateFunction(support_ticket), {
          state: {
            open: false,
            support_ticket,
            api_recall: "recall",
          },
        });
      } else if (notification_type == "daily_dynamite_reminder") {
        navigate("/tracker", {
          state: {},
        });
      } else if (notification_type == "dynamite_streak_reminder") {
        navigate("/performance-streak", {
          state: {},
        });
      } else if (notification_type == "support_ticket_internal_note") {
        navigate(navigateFunction(support_ticket), {
          state: { open: true, support_ticket },
        });
      } else if (notification_type == "move_support_ticket_to_fixes") {
        navigate(`/support-ticket`, {
          state: { tabValue: 2 },
        });
      } else if (notification_type == "goal_statement_completed") {
        navigate(`/member-completed-goalstatements/${send_id}`);
      } else if (notification_type == "close_support_ticket") {
        navigate(`/contact-support`);
      } else if (notification_type == "move_support_ticket_to_attention") {
        navigatechangeStatus(support_ticket);
      } else if (notification_type === "event_reminder") {
        if (data?.event_id?.created_for == "consultant_user") {
          navigate(`/delegate-events`);
        } else {
          navigate(`/calendar-events`);
        }
      } else if (notification_type === "message") {
        navigate(`/chat?chat_id=${data.message.chat_id}`);
      } else if (feed_id) {
        let path = `/thesource/feed-detail/${feed_id}`;
        if (data.feeds?.feed_created_for == "event") {
          path = `/live-events/${data.feeds.dynamite_event}/feed-detail/${feed_id}`;
        } else if (data.tab_type == "program" && data.module_info) {
          path = `/delegate-training/${data.module_info.program_slug}/feed-detail/${feed_id}`;
        } else if (data.tab_type == "mission" && data.module_info) {
          const { mission_id, level_id, mission_type } = data.module_info;
          if (mission_type == "mission") {
            localStorage.setItem("tabValuesMission", 1);
            path = `/mission-levels/${level_id}/mission/${mission_id}/feed-detail/${feed_id}`;
          } else {
            localStorage.setItem("tabValuesMission", 2);
            path = `/mission-levels/${level_id}/quest/${mission_id}/feed-detail/${feed_id}`;
          }
        } else if (data.feeds?.feed_created_for == "delegate") {
          path = `/thesource/feed-detail/${feed_id}`;
        } else if (data.feeds?.feed_created_for == "general") {
          let access_thesouce = consultantDetail.nav_items.find(
            (item) => item.value == "the_source_feed"
          );
          if (access_thesouce) {
            path = `/sourcefeeds/feed-detail/${feed_id}`;
          } else {
            let access_allsouce = consultantDetail.nav_items.find(
              (item) => item.value == "all_source_feed"
            );
            if (access_allsouce) {
              path = `/all-sourcefeeds/feed-detail/${feed_id}`;
            }
          }
        }

        navigate(path);
      } else {
        navigate(`/`);
      }
    } else {
      setIsLoadingMore(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleMarkAllAsRead = () => {
    setUnreadNotificationCount(0);
    read_all_notification();
    setNotifications(
      notifications.map((notification) => ({
        ...notification,
        is_seen: true,
      }))
    );
  };

  useEffect(() => {
    setPageNumber(0);
    setTotalPages(0);
    setIsLoading(true);
    if (open) {
      getMoreNotificationList([], loadMore);
    }
  }, [open]);

  const showNotification = (_data) => {
    console.log(_data, "show notifiction");
    const notification = new Notification("New Notification", {
      body: _data.body,
      icon: _data.icon,
    });
    notification.onclick = async function (event) {
      event.preventDefault();
      handleRedirect(
        _data.notification_id,
        _data.feed_id,
        _data.notification_type,
        _data.support_ticket_id,
        _data.send_id,
        _data
      );
    };
  };
  const showSocketNotification = (_data) => {
    console.log(_data, "_data_data_data_data");
    const dataObject = {
      ..._data,
      action: _data.action,
      body: _data.action_response.notification?.notification_title,
      icon:
        s3baseUrl +
        _data.action_response.notification.user_info_sender?.profile_image,
      feed_id: _data.feed_id,
      notification_id: _data.action_response.notification._id,
      notification_type: _data.action_response.notification.notification_type,
      support_ticket_id: _data?.action_response?.notification?.support_ticket,
    };
    console.log("caleed");
    if (Notification.permission === "granted") {
      showNotification(dataObject);
      console.log("granted");
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        console.log("denied");
        if (permission === "granted") {
          showNotification(dataObject);
          console.log(" denied  granted");
        }
      });
    }
  };
  const showSocketNotificationFeed = (_data) => {
    let profileImage;
    if (_data.action_response?.user_info_sender?.profile_image) {
      profileImage =
        s3baseUrl + _data.action_response?.user_info_sender?.profile_image;
    } else {
      profileImage = imagePlaceHolder;
    }
    const action = _data.action;
    const dataObject = {
      action: _data.action,
      body: _data.action_response.notification.notification_title,
      icon:
        s3baseUrl +
        _data.action_response?.notification?.user_info_sender?.profile_image,
      feed_id: _data.feed_id,
      notification_id: _data.action_response.notification._id,
      notification_type: _data.action_response.notification.notification_type,
      send_id: _data.action_response.notification.sender,
      support_ticket_id: _data?.action_response?.notification?.support_ticket,
    };
    if (Notification.permission === "granted") {
      showNotification(dataObject);
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          showNotification(dataObject);
        }
      });
    }
  };
  const showSocketNotificationSupport = (_data, notification) => {
    let image;
    if (_data.action_response.notification.sender?.profile_image) {
      image =
        s3baseUrl + _data.action_response.notification.sender?.profile_image;
    } else if (
      _data.action_response.notification.user_info_sender.profile_image
    ) {
      image =
        s3baseUrl +
        _data.action_response.notification.user_info_sender.profile_image;
    } else {
      image = imagePlaceHolder;
    }
    const dataObject = {
      action: _data.action,
      body: _data.action_response.notification.notification_title,
      icon: image,
      feed_id: _data.feed_id,
      notification_id: notification._id,
      notification_type: _data.action ? _data.action : "support_ticket",
      support_ticket_id: _data?.action_response?.notification?.support_ticket,
    };
    if (Notification.permission === "granted") {
      showNotification(dataObject);
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          showNotification(dataObject);
        }
      });
    }
  };

  useEffect(() => {
    socket.on("new_notification_receiver_for_delegate", (data) => {
      console.log(data, "new_notification_receiver_for_delegate");
      let count = data.data?.action_response?.unread_notification_count.find(
        (value) => value._id == userInfo._id
      );
      if (count) {
        setUnreadNotificationCount(count.unread_notification_count);
      }
      if (
        data.action === "feedunlike" ||
        data.action === "commentunlike" ||
        data.action === "delete_comment" ||
        data.action === "delete_comment_reply"
      ) {
        setNotifications((notifications) => {
          return notifications.filter(
            (notification) =>
              notification._id !== data.action_response.notification
          );
        });
      } else if (
        data.action === "commentlike" ||
        data.action === "feedlike" ||
        data.action === "gratitude" ||
        data.action === "add_comment" ||
        data.action === "goal_statement_save_and_close_status" ||
        data.action === "add_comment_reply"
      ) {
        setNotifications((notifications) => [
          data.action_response.notification,
          ...notifications,
        ]);
        data.tab_type = data.action_response.notification?.tab_type;
        data.module_info = data.action_response.notification?.module_info;
        console.log(data, "datadatadatadata 11");
        showSocketNotification(data);
      } else if (
        data.data.action === "add_support_ticket" ||
        data.data.action === "support_ticket_comment" ||
        data.data.action === "move_support_ticket_to_fixes" ||
        data.data.action === "move_support_ticket_to_attention"
      ) {
        let notification_array =
          data.data.action_response.notification_array.find(
            (value) => value.reciever == userInfo._id
          );

        if (notification_array) {
          setNotifications((notifications) => [
            data.data.action_response.notification,
            ...notifications,
          ]);
          showSocketNotificationSupport(data.data, notification_array);
        }
      }
    });
    socket.on("goal_stetement_event_reciever", (data) => {
      setUnreadNotificationCount(
        data.data.action_response.unread_notification_count
      );
      if (
        data.data.action_response.action === "feedunlike" ||
        data.data.action_response.action === "commentunlike" ||
        data.data.action_response.action === "delete_comment" ||
        data.data.action_response.action === "delete_comment_reply"
      ) {
        setNotifications((notifications) => {
          return notifications.filter(
            (notification) =>
              notification._id !== data.action_response.notification
          );
        });
      } else if (
        data.data.action_response.action === "goal_statement_completed"
      ) {
        setNotifications((notifications) => [
          data.data.action_response.notification,
          ...notifications,
        ]);
        showSocketNotification(data.data);
      }
    });
    socket.on("new_notification_receiver", (data) => {
      console.log(data, "new_notification_receiver");
      setUnreadNotificationCount(
        data.action_response.unread_notification_count
      );
      if (
        data.action === "feedunlike" ||
        data.action === "commentunlike" ||
        data.action === "delete_comment" ||
        data.action === "poll_answer_removed" ||
        data.action === "survey_answer_removed" ||
        data.action === "delete_comment_reply"
      ) {
        setNotifications((notifications) => {
          return notifications.filter(
            (notification) =>
              notification._id !== data.action_response.notification
          );
        });
      } else if (
        data.action === "commentlike" ||
        data.action === "feedlike" ||
        data.action === "gratitude" ||
        data.action === "add_comment" ||
        data.action === "goal_statement_save_and_close_status" ||
        data.action === "poll_answer" ||
        data.action === "survey_answer" ||
        data.action === "add_comment_reply"
      ) {
        setNotifications((notifications) => [
          data.action_response.notification,
          ...notifications,
        ]);
        data.tab_type = data.action_response.notification?.tab_type;
        data.module_info = data.action_response.notification?.module_info;
        showSocketNotification(data);
      }
    });
    socket.on("reminder_event_for_delegate", (data) => {
      let find_user = data.final_delegate_array.find(
        (user) => user.user_id == userInfo._id
      );
      if (find_user) {
        setUnreadNotificationCount(find_user.unread_notification_count);

        if (find_user.notification.length > 0) {
          find_user.notification.map((notification) => {
            let data_object = {
              action: notification.notification_type,
              action_response: {
                notification: {
                  ...notification,
                  notification_title: notification.message,
                },
              },
            };
            showSocketNotification(data_object);
          });
        }
      }
    });
    socket.on("mention_user_event_trigger", (data) => {
      console.log(data, "mention_user_event_trigger");
      let find_user = data.action_response.notification_users.find(
        (user) => user.user_id == userInfo._id
      );
      if (find_user) {
        setUnreadNotificationCount(find_user.unread_notification_count);
        let data_object = {
          ...find_user.notification,
          action: "feed_mentioned",
          feed_id: data.feed_id,
          action_response: {
            notification: {
              ...find_user.notification,
              notification_title: data.action_response.notification_statement,
            },
          },
        };
        showSocketNotification(data_object);
      }
    });
    socket.on("comment_mention_user_event_trigger", (data) => {
      console.log(data, "comment_mention_user_event_trigger");
      let find_user = data.action_response.notification_users.find(
        (user) => user.user_id == userInfo._id
      );
      if (find_user) {
        setUnreadNotificationCount(find_user.unread_notification_count);
        let data_object = {
          ...find_user.notification,
          action: "comment_mentioned",
          feed_id: data.action_response.feed._id,
          feed: data.action_response.feed,
          action_response: {
            notification: {
              ...find_user.notification,
              notification_title: data.action_response.notification_statement,
            },
          },
        };
        showSocketNotification(data_object);
      }
    });
    socket.on("daily_dynamite_reminder_event", (data) => {
      if (data.user_id == userInfo._id) {
        setUnreadNotificationCount(data.unread_notification_count);
        if (data.notification.length > 0) {
          data.notification.map((notification) => {
            let data_object = {
              action: notification.notification_type,
              action_response: {
                notification: {
                  ...notification,
                  notification_title: notification.message,
                },
              },
            };
            showSocketNotification(data_object);
          });
        }
      }
    });
    socket.on("dynamite_streak_event", (data) => {
      if (data.user_id == userInfo._id) {
        setUnreadNotificationCount(data.unread_notification_count);
        if (data.notification.length > 0) {
          data.notification.map((notification) => {
            let data_object = {
              action: notification.notification_type,
              action_response: {
                notification: {
                  ...notification,
                  notification_title: notification.message,
                },
              },
            };
            showSocketNotification(data_object);
          });
        }
      }
    });

    return () => {
      socket.off("reminder_event_for_delegate");
    };
  }, []);

  const MarkAsRead = (row) => {
    read_notification_by_id(row._id);
    setNotifications((old) => {
      return old.map((item) => {
        if (item._id == row._id) {
          return {
            ...item,
            is_seen: true,
          };
        }
        return item;
      });
    });
    setUnreadNotificationCount((old) => old - 1);
  };
  const handleAgreeDelete = (row) => {
    delete_member_notification(row._id);
    setNotifications((old) => {
      return old.filter((item) => item._id !== row._id);
    });
    if (!row.is_seen) {
      setUnreadNotificationCount((old) => old - 1);
    }
  };

  const handleAllDelete = () => {
    setOpenDelete(false);
    delete_member_notification("all");
    setNotifications([]);
    setUnreadNotificationCount(0);
    setTotalPages(0);
    setPageNumber(0);
  };

  const handleOpenAllDelete = () => {
    setOpenDelete(true);
  };

  const handle_menu_options = (row) => {
    let MENU_OPTIONS = [];
    if (!row.is_seen) {
      MENU_OPTIONS.push({
        label: "Mark as read",
        icon: "solar:check-read-linear",
        handleClick: MarkAsRead,
      });
    }
    MENU_OPTIONS.push({
      label: "Remove this notification",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    });
    return MENU_OPTIONS;
  };

  useEffect(() => {
    setUnreadNotificationCount(notificationsCount);
  }, [notificationsCount]);

  return (
    <>
      <RootStyle
        style={{
          backgroundColor: get_root_value("--background-primary-color"),
        }}
      >
        <ToolbarStyle>
          {/* <MHidden width="lgUp"> */}
          <div className="side-barIcon-container">
            <IconButton
              onClick={onOpenSidebar}
              sx={{ mr: 1, color: "text.primary", marginRight: "auto" }}
            >
              <Icon icon={menu2Fill} />
            </IconButton>
          </div>

          {/* </MHidden> */}
          {/* <Searchbar /> */}
          <Box sx={{ flexGrow: 1 }} className="header-logo">
            <Logo consultantInfo={consultantInfo?.brand_logo_2} />
          </Box>
          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 0.5, sm: 1.5 }}
          >
            {/* <LanguagePopover /> */}

            {isAccess.is_chat_allowed && <ChatButton />}
            <NotificationsPopover
              notifications={notifications}
              isLoadingMore={isLoadingMore}
              setIsLoadingMore={setIsLoadingMore}
              totalPages={totalPages}
              pageNumber={pageNumber}
              unreadNotificationCount={unreadNotificationCount}
              getMoreNotificationList={getMoreNotificationList}
              loadMorePath={loadMorePath}
              handleRedirect={handleRedirect}
              handleMarkAllAsRead={handleMarkAllAsRead}
              handleOpenAllDelete={handleOpenAllDelete}
              handle_menu_options={handle_menu_options}
              setOpen={setOpen}
              open={open}
            />
            <AccountPopover />
            {/* <FormControlLabel
            value="start"
            control={
              <Switch
                color="primary"
                value={mode}
                onChange={(e) => handleChangeMode(e.target.checked)}
              />
            }
            label="Dark Mode"
            labelPlacement="start"
          /> */}
          </Stack>
        </ToolbarStyle>
      </RootStyle>

      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to remove all notifications?"}
        handleAgree={handleAllDelete}
      />
    </>
  );
}
